import React, {FC, useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import styles from './Sidebar.module.scss';
import {NavLink, useHistory} from 'react-router-dom';
import profileActive from './../../assets/images/icons/SidebarIcons/profile_active.svg';
import profileInctive from './../../assets/images/icons/SidebarIcons/profile_inactive.svg';
import rateInctive from './../../assets/images/icons/SidebarIcons/rate_inactive.svg';
import rateActive from './../../assets/images/icons/SidebarIcons/rate_active.svg';
import analyticsInactive from './../../assets/images/icons/SidebarIcons/analytics_inactive.svg';
import analyticsActive from './../../assets/images/icons/SidebarIcons/analytics_active.svg';
import requestInactive from './../../assets/images/icons/SidebarIcons/request_inactive.svg';
import requestActive from './../../assets/images/icons/SidebarIcons/request_active.svg';
import earningInactive from './../../assets/images/icons/SidebarIcons/earning_inactive.svg';
import earningActive from './../../assets/images/icons/SidebarIcons/earn_active.svg';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import {makeStyles} from '@mui/styles';
import {mediakitUserExist} from '../../Helper/generalHelper';
import PlatformSwitcher from '../PlatformSwitcher';
import {useSelector} from 'react-redux';
import {getConfig} from '../../features/stores/config.slice';
import {haveSegmentPermission} from '../../features/util';

const useStyles = makeStyles({
  root: {
    'borderRadius': '27px',
    'width': 'auto',
    'boxShadow': 'rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em',
    "& .MuiBottomNavigationAction-root": {
      "@media (max-width: 420px)": {
        minWidth: "50px",
        padding: "0",
      },
      "& .MuiBottomNavigationAction-wrapper": {
        "& .MuiBottomNavigationAction-label": {
          "fontSize": '12px',
          "@media (max-width: 360px)": {
            fontSize: '11px',
          },
        },
      },
    },
  },
});

const headerRoutes = [
    {
      key: 'myprofile',
      route: '/mediakit/profile/my-profile',
      name: 'Profile',
      label: '',
      icon: profileInctive,
      activeIcon: profileActive,
    },
    {
      key: 'rates',
      route: '/mediakit/profile/rates',
      name: 'Rate',
      label: '',
      icon: rateInctive,
      activeIcon: rateActive,
    },
    {
      key: 'analytics',
      route: '/mediakit/profile/analytics',
      name: 'Analytics',
      label: '',
      icon: analyticsInactive,
      activeIcon: analyticsActive,
    },
    {
      key: 'request',
      route: '/mediakit/profile/request',
      name: 'Request',
      label: '',
      icon: requestInactive,
      activeIcon: requestActive,
    },
    // {
    //   key: 'earnings',
    //   route: '/mediakit/profile/earnings',
    //   name: 'Earnings',
    //   label: '',
    //   icon: earningInactive,
    //   activeIcon: earningActive,
    // },
];

const Sidebar: FC = () => {
    const {t, i18n} = useTranslation();
    const [active, setActive] = useState(window?.location?.pathname || '');
    const config = useSelector(getConfig).data || [];
    const monetizeEnabled = haveSegmentPermission(config, 'monetize') || false;
    const classes = useStyles();
    const history = useHistory();
    const userExist = mediakitUserExist();
    const finalHeaderRoutes = monetizeEnabled ? headerRoutes : headerRoutes.filter((e) => e.key != 'rates');
    const setPathActivation = (match: unknown, pathname: string) => {
        if (pathname === '/') {
          setActive('/mediakit/profile/my-profile');
          if (!match) return false;
          return true;
        }
        if (!match) {
          setActive(pathname);
          return false;
        }
        if (pathname === '/mediakit/profile/rates') {
          setActive('/mediakit/profile/rates');
          return true;
        }
        if (pathname.includes('/mediakit/profile/my-profile')) {
          setActive('/mediakit/profile/my-profile');
          return true;
        }
        if (pathname.includes('/mediakit/profile/analytics')) {
          setActive('/mediakit/profile/analytics');
          return true;
        }
        if (pathname.includes('/mediakit/profile/request')) {
          setActive('/mediakit/profile/request');
          return true;
        }
        setActive('/');
        return true;
      };
    const setPathActivationMobile = (pathname: string) => {
        history.push(pathname);
    };
    return (
        <>
        <div className={styles.sidebar_container}>
            <PlatformSwitcher />
            <div className={styles.routes_container}>
                {
                    finalHeaderRoutes.map((route: any) => {
                        return (
                          <div className={`${styles.route} ${(route.route === active || active.includes(route?.pathMath)) ? styles.active : ''}`} key={route.key}>
                            <NavLink
                              to={route.route}
                              activeClassName={styles.route_active}
                              isActive={(match, location) => setPathActivation(match, location?.pathname)
                              }
                            >
                              <img
                                src={route.route === active || active.includes(route?.pathMath) ? route.activeIcon : route.icon}
                                alt={route.key}
                                className={styles.route_img}
                              />
                              <p className={route.route === active || active.includes(route?.pathMath) ? styles.route_active : styles.route_description}>{t(route.name)}</p>
                            </NavLink>
                          </div>
                        );
                      })
                }
            </div>
        </div>
        <div className={styles.sidebar_container_mobile}>
          <BottomNavigation value={active} onChange={(event: React.ChangeEvent<{}>, path: string) => setPathActivationMobile(path)} className={classes.root}>
          {finalHeaderRoutes.map((route: any) =>
              <BottomNavigationAction showLabel key={`mobile-${route.route}`} label={t(route.name)} value={route.route} icon={<img
                src={route.route === active || active.includes(route?.pathMath) ? route.activeIcon : route.icon}
                alt={route.key}
                className={styles.route_img}
              />} />,
          )}
          </BottomNavigation>
        </div>
        </>
    );
};

export default Sidebar;
